import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import environmentReportTableColumns from './environmentReportColumns'
import type { Environment } from '../../../../../../types'
import type { Row } from '@tanstack/react-table'
import { formatNumber } from '../../../utils/formatNumber'

type EnvironmentReportTableProps = {
  data: any
  isLoading?: boolean
}

function EnvironmentReportTable({ data, isLoading }: EnvironmentReportTableProps) {
  const columns = environmentReportTableColumns()

  return (
    <GenericTable
      className="max-h-[50vh]"
      data={data}
      isLoading={isLoading}
      columns={columns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} />
      }}
    />
  )
}

export default EnvironmentReportTable

function MobileCardContent({ row }: { row: Row<Environment> }) {
  const header = row.original?.regNo || row.original?.vehicleID
  const data = [
    {
      label: 'Objekt',
      value: row.original.carDescription || '',
    },
    {
      label: 'Fakturagruppe',
      value: row.original.invoiceGroup || '',
    },
    {
      label: 'Kilometer',
      value: formatNumber(row.original.totalKm),
    },
    {
      label: 'Liter',
      value: formatNumber(row.original.volume),
    },
    {
      label: 'Drivstoff',
      value: row.original.fuelType || '',
    },
    {
      label: 'L/mil',
      value: formatNumber(row.original.fuelConsumptionL10KM),
    },
    {
      label: 'CO2',
      value: `${formatNumber(row.original.co2Emission)} g`,
    },
    {
      label: 'NOX',
      value: `${formatNumber(row.original.nOXEmission)} g`,
    },
  ]

  return <TableMobileCardContent header={header} data={data} />
}
